<template>
  <v-img v-if="!fotoUrl" src="/images/avatares/avatar-padrao.png" :class="classAvatar" aspect-ratio="4/3"/>
  <v-img v-else :src="createUrl(fotoUrl)" :class="classAvatar" aspect-ratio="4/3" lazy-src="/images/loading.gif"/>
</template>

<script>
export default {
    name: 'fotoAvatar',
    props: {
        fotoUrl: {
            type: String,
        },
        classAvatar: {
            type: String,
            default: 'foto-avatar'
        },
    },
}
</script>

<style scoped lang="stylus">

.foto-avatar
  height 90px
  width 90px
  border-radius 50%
  border 2px solid #eee

</style>